export default __webpack_public_path__ + "static/media/renovar.95a483f8.png";